import { Link } from 'react-router-dom';
import CtaBand from '../components/CtaBand';
import FaqList from '../components/FaqList';
import Icon from '../components/Icon';
import Layout, { PageHero } from '../components/Layout';
import { guidePath } from '../constants/guides';

/** Shared layout for the FTM 2024 and FTM 2019 edition pages. */
export default function EditionPage({ edition }) {
  return (
    <Layout>
      <PageHero eyebrow={edition.eyebrow} title={edition.title} lead={edition.lead} crumbs={[{ label: edition.crumb }]} />

      <section className="section">
        <div className="container split">
          <div className="split__copy">
            <p className="eyebrow">Overview</p>
            <h2>{edition.overviewTitle}</h2>
            {edition.overview.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
          <div className="split__media">
            <img src={edition.image} alt={edition.imageAlt} width="640" height="480" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="section section--parchment">
        <div className="container">
          <div className="section-head">
            <p className="eyebrow">Key features</p>
            <h2>{edition.featuresTitle}</h2>
          </div>
          <div className="card-grid card-grid--3">
            {edition.features.map((f) => (
              <article key={f.title} className="service-card">
                <span className="service-card__icon">
                  <Icon name={f.icon} size={24} />
                </span>
                <h3>{f.title}</h3>
                <p>{f.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <p className="eyebrow">System requirements</p>
            <h2>Will it run on my computer?</h2>
            <p>Typical requirements — always confirm against the publisher’s latest specifications.</p>
          </div>
          <div className="table-wrap">
            <table className="spec-table">
              <thead>
                <tr>
                  <th scope="col">Component</th>
                  <th scope="col">Windows</th>
                  <th scope="col">Mac</th>
                </tr>
              </thead>
              <tbody>
                {edition.specs.map(([label, win, mac]) => (
                  <tr key={label}>
                    <th scope="row">{label}</th>
                    <td>{win}</td>
                    <td>{mac}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="section section--forest">
        <div className="container split">
          <div className="split__copy">
            <p className="eyebrow eyebrow--light">Common issues</p>
            <h2>{edition.issuesTitle}</h2>
            <p>Each issue links to a free guide. Or skip the reading and let a technician help in live chat.</p>
          </div>
          <ul className="fix-list">
            {edition.issues.map(([label, slug]) => (
              <li key={label}>
                <Link to={guidePath(slug)}>
                  <Icon name="leaf" size={20} />
                  <span>{label}</span>
                  <Icon name="arrow" size={18} />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section">
        <div className="container container--narrow">
          <div className="section-head">
            <p className="eyebrow">Questions</p>
            <h2>{edition.crumb} FAQs</h2>
          </div>
          <FaqList items={edition.faqs} />
        </div>
      </section>

      <CtaBand title={edition.ctaTitle} />
    </Layout>
  );
}
